import React, { useEffect, useState } from "react";
import {
  Container,
  Row,
  Col,
  Card,
  Form,
  Button,
  Spinner,
} from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import { useNavigate } from "react-router-dom";
import { useForm } from "react-hook-form";
import api from "../utils/helper";
import { useAuth } from "../context/AuthContext";
import { useIDsContext } from "../context/IDsContext";
import { useMutation } from "react-query";
import "../pages/teacher/index.css";

const Login = () => {
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

  const navigate = useNavigate();
  const { login } = useAuth();

  const loginMutation = useMutation({
    mutationFn: (credentials) =>
      api.login("/auth/login", credentials, "super_admin"),
    onSuccess: (response) => {
      localStorage.clear();
      const userData = response?.data?.data?.user;

      
      // Store in localStorage
      localStorage.setItem("email", userData?.email);
      localStorage.setItem("profile_img", userData?.profile_img);
      localStorage.setItem("phone", userData?.phone);

      login(
        response?.data?.data?.user?.firstname,
        "super_admin",
        response?.data?.data?.token,
        response?.data?.data?.user?._id
      );
      navigate("/");
    },
   
  });

  const handleLogin = (data) => {
    loginMutation.mutate({ ...data, role: "super_admin" });
  };

  const handleForgot = async () => {
    navigate("/forgot-password");
  };

  return (
    <Container fluid className="h-100">
      {console.log(loginMutation, "loginMutation")}
      <Row className="h-100 position-relative">
        <Col
          md={12}
          className="d-flex align-items-start justify-content-center flex-column p-3 loginbg"
        >
          <div className="d-flex justify-content-center w-100 py-4">
            <img
              src="/images/Group 1.png"
              alt="Logo"
              className="me-3 m-logo"
              style={{ height: "35px" }}
            />
          </div>

          <div className="login-card card-border">
            <Card className=" shadow card-border">
              <Card.Header className="d-flex card-border align-items-center justify-content-between p-3 login-header">
                <img
                  src="/images/logoblue.png"
                  alt="Logo"
                  className="me-3 d-logo"
                  style={{ height: "35px" }}
                />
                <h4 className="mb-0 fw-bold login-title">SUPER ADMIN PANEL</h4>
              </Card.Header>

              <Card.Body>
                <Form
                  onSubmit={handleSubmit(handleLogin)}
                  className="login-form w-75 w-md-100 m-auto"
                >
                  <div className="text-center welcome-text mb-3">
                    <Form.Text>
                      Welcome! Please, enter your credentials
                    </Form.Text>
                  </div>
                  <Form.Group className="mb-3">
                    <Form.Label>Email</Form.Label>
                    <Form.Control
                      placeholder="Enter your email"
                      type="email"
                      {...register("email", {
                        required: "Email is required",
                        pattern: {
                          value:
                            /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/,
                          message: "Invalid email format",
                        },
                      })}
                    />
                    {errors.email && (
                      <p className="text-danger family-inter">
                        {errors.email.message}
                      </p>
                    )}
                  </Form.Group>

                  <Form.Group className="mb-3">
                    <Form.Label>Password</Form.Label>
                    <Form.Control
                      placeholder="••••••••"
                      type="password"
                      {...register("password", {
                        required: "Password is required",
                        minLength: {
                          value: 6,
                          message: "Password must be at least 6 characters",
                        },
                      })}
                    />
                    {errors.password && (
                      <p className="text-danger family-inter">
                        {errors.password.message}
                      </p>
                    )}
                  </Form.Group>

                  <Form.Group className="mb-3 d-flex justify-content-between align-items-center">
                    <Form.Check
                      type="checkbox"
                      label="Remember me"
                      // checked={rememberMe}
                      // onChange={(e) => setRememberMe(e.target.checked)}
                    />
                  </Form.Group>

                  {loginMutation?.error && (
                    <p className="text-danger family-inter">
                      {loginMutation?.error?.response?.data?.message ||
                        "Login Failed!"}
                    </p>
                  )}

                  <Button
                    variant="primary"
                    type="submit"
                    className="w-100 mb-3"
                  >
                    {loginMutation.isLoading ? (
                      <span className=" text-white">
                        {" "}
                        <Spinner size="sm" /> Loading...
                      </span>
                    ) : (
                      "Sign in"
                    )}
                  </Button>
                </Form>
              </Card.Body>

              <Card.Footer className="p-0"></Card.Footer>
            </Card>
            <Button
              variant="outline-secondary"
              className="forgot-btn color-white border-none"
              onClick={handleForgot}
              style={{
                height: "43px",
                display: "flex",
                justifyContent: "center",
                gap: "2%",
                textAlign: "center",
                alignItems: "center",
              }}
            >
              Forgot password?
              <a
                className="btnhere text-white"
                style={{ textDecoration: "underline" }}
              >
                Reset here
              </a>
            </Button>
          </div>
        </Col>
      </Row>
    </Container>
  );
};

export default Login;
